import React from "react";
import { withStyles, createStyles } from "@material-ui/core/styles";
import { Colors } from "../../styles";
import { Paper } from "@material-ui/core";

interface Props {
    children?: React.ReactNode;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    classes: any;
    icon: React.ReactNode;
    content: React.ReactNode;
    useSwitch?: React.ReactNode;
    detailCondition?: boolean;
    detail?: React.ReactNode;
    footerContent?: React.ReactNode;
}

export const BoxedInputWithIconAndOptionalSwitch = withStyles(() =>
    createStyles({
        container: {
            padding: 24,

            marginTop: 16,

            borderColor: Colors.anthracite25,
            borderWidth: "1px",
            borderStyle: "solid",
            borderRadius: 8,

            display: "flex",
            flexDirection: "column",
            position: "relative",
        },
        baseRow: {
            display: "flex",
            flexDirection: "row",
        },
        detailRow: {
            display: "flex",
            flexDirection: "row",
            marginBottom: 40
        },
        icon: { width: 64, height: 64, marginRight: 8 },
        content: { flex: 1, marginLeft: 16 },
        footerContent: { flex: 1, marginLeft: 88, marginRight: 80 },
        useSwitch: { width: 64 },
    }),
)(({ classes, icon, content, footerContent, useSwitch, detailCondition, detail }: Props) => {
    return (
        <Paper className={classes.container}>
            <div className={classes.baseRow}>
                <div className={classes.icon}>{icon}</div>
                <div className={classes.content}>{content}</div>
                {useSwitch && <div className={classes.useSwitch}>{useSwitch}</div>}
            </div>
            {!!detailCondition && (
                <div className={classes.detailRow}>
                    <div className={classes.icon}></div>
                    <div className={classes.content}>{detail}</div>
                </div>
            )}
            <div className={classes.footerContent}>{footerContent}</div>
        </Paper>
    );
});
